
import styled from 'styled-components';
import { CtaIconCardProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import { Svg } from '@/components/styled';
import { List as IconsList } from '@/public/img/icons';
import { renderIcons } from '@/utilities/functions';

const CtaIconCardContainer = styled.div`
	border-radius: 6px;
	box-shadow: ${({ theme }) => `
		0px 0px 10px rgba(${theme.color.rgbPrune}, .1);
	`};
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 1.25rem;
	transition: .25s;
	min-height: 17rem;
	width: 32rem;

	.content-container {
		.title-container {
			position: relative;
			box-sizing: border-box;
			color: ${({ theme }) => theme.color.prune};
			display: flex;
			gap: 0 .5rem;
			align-items: center;
			font-size: ${({ theme }) => theme.fontSize.XLARGE};
			font-weight: bold;
			margin: 0;
			width: 100%;
		}
		.description {
			min-height: 10rem;
			max-height: 10rem;
			display: inline-block;
			color: ${({ theme }) => theme.color.black};
			overflow: auto;
		}
	}

	.button {
		padding: 0;
	}

	:hover {
		transform: translateY(-3px);
		box-shadow: ${({ theme }) => `
			0px 0px 15px rgba(${theme.color.rgbPrune}, .1);
		`};
	}
`;

const CtaIconCard = ({ card }: { card: CtaIconCardProps }) => {

	return (
		<CtaIconCardContainer>
			<div className='content-container'>
				<div className='title-container'>
					{card.icon && (
						<Svg
							color={card.icon.color ?? 'prune'}
							size={{
								height: '48px',
								width: '48px',
							}}
						>
							{renderIcons(card.icon.name, IconsList)}
						</Svg>
					)}
					{card.title}
				</div>
				<div className='description'>
					{card.description}
				</div>
			</div>
			{card.button && (
				<Button_v2
					className='button'
					gtm_id={card.button.trackerId}
					href={card.button.url}
					openOnNewTab={card.button.newTab}
					text={card.button.text}
					version={card.button.variant}
				/>
			)}
		</CtaIconCardContainer>
	);
};

export default CtaIconCard;
